var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from 'react';
import { OutputNodeDeleteWrapper, Heading5, ScopeButtonWrapper, AsyncLogicHeadingWrapper, OutputInputWrapper, ScopeWrapper, OutputHeaderWrapper, } from './styles';
import { Label } from '../../containers/PushNotifications/styles';
import { faPlus } from '@fortawesome/pro-regular-svg-icons/faPlus';
import { Spacer } from '../base';
import { Button as UIKitButton } from '@appspotr/ui-kit';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashAlt } from '@fortawesome/pro-regular-svg-icons/faTrashAlt';
import { faArrowsRotate } from '@fortawesome/pro-regular-svg-icons/faArrowsRotate';
import { COLORS } from '../../themes';
import { generateShortUUID } from 'utils';
import { ReactiveInput } from 'components/Forms/Fields/ReactiveInput';
import toast from '../Toast';
import { TooltipSideBar } from 'app-builder/utils/tooltipConfig';
var AsyncLogicOutputComponent = function (_a) {
    var output_nodes = _a.settings.output_nodes, onSettingsChange = _a.onSettingsChange, reloadPatchwork = _a.reloadPatchwork, edges = _a.edges, patch = _a.patch;
    var _b = useState(output_nodes || []), outputNodes = _b[0], setOutputNodes = _b[1];
    return (_jsxs(_Fragment, { children: [_jsx(AsyncLogicHeadingWrapper, { children: _jsxs(OutputHeaderWrapper, { children: [_jsx(Heading5, { children: "Output Events" }), _jsx(OutputNodeDeleteWrapper, { children: _jsx(FontAwesomeIcon, { icon: faArrowsRotate, color: COLORS.primary, onClick: reloadPatchwork }) })] }) }), outputNodes === null || outputNodes === void 0 ? void 0 : outputNodes.map(function (opNode, index) {
                var _a;
                var outputUpdateDisabled = edges.some(function (edge) {
                    return edge.from_patch === patch.id &&
                        edge.from_arg === "out:".concat(opNode === null || opNode === void 0 ? void 0 : opNode.name);
                });
                return (_jsx(ScopeWrapper, { children: _jsx(OutputInputWrapper, { children: _jsxs(OutputHeaderWrapper, { children: [_jsx(ReactiveInput, { name: "outputName", initialValue: (_a = opNode === null || opNode === void 0 ? void 0 : opNode.name) !== null && _a !== void 0 ? _a : '', disabled: outputUpdateDisabled, onChange: function (_, value) {
                                        var nameAlreadyExist = outputNodes.find(function (node) { return node.name === value && node.id !== opNode.id; });
                                        if (value && !nameAlreadyExist) {
                                            var updatedOutputNodes = outputNodes.map(function (node) {
                                                if (node.id === opNode.id) {
                                                    return __assign(__assign({}, node), { name: value });
                                                }
                                                return node;
                                            });
                                            if (outputNodes.length === updatedOutputNodes.length) {
                                                setOutputNodes(updatedOutputNodes);
                                                onSettingsChange('output_nodes', updatedOutputNodes);
                                            }
                                        }
                                        else {
                                            nameAlreadyExist
                                                ? toast.error("Output name can't be duplicate")
                                                : toast.error("Output name can't be empty");
                                        }
                                    }, onKeyDown: function (e) {
                                        return e.stopPropagation();
                                    }, placeholder: "Output Name", type: "text" }, opNode.id), _jsx(OutputNodeDeleteWrapper, { children: outputUpdateDisabled ? (_jsx(TooltipSideBar, __assign({ title: _jsx(_Fragment, { children: "Remove the connected edge before delete the output node" }) }, { children: _jsx(FontAwesomeIcon, { icon: faTrashAlt, color: COLORS.reddishGray }) }))) : (_jsx(FontAwesomeIcon, { icon: faTrashAlt, color: COLORS.redColor, onClick: function () {
                                            var filteredArray = outputNodes.filter(function (op) { return op.id !== opNode.id; });
                                            if (outputNodes.length === filteredArray.length + 1) {
                                                setOutputNodes(filteredArray);
                                                onSettingsChange('output_nodes', filteredArray);
                                            }
                                        } })) })] }) }) }, index));
            }), outputNodes.length < 5 ? (_jsx(ScopeButtonWrapper, { children: _jsxs(UIKitButton, __assign({ type: "outline", onClick: function () {
                        var generatedId = generateShortUUID();
                        var newIndex = 0;
                        if (outputNodes.length) {
                            newIndex = outputNodes[outputNodes.length - 1].index + 1;
                        }
                        var newOutput = {
                            id: generatedId,
                            name: "Output ".concat(newIndex),
                            index: newIndex,
                        };
                        var updatedOutputs = __spreadArray(__spreadArray([], outputNodes, true), [newOutput], false);
                        if (outputNodes.length === updatedOutputs.length - 1) {
                            setOutputNodes(updatedOutputs);
                            onSettingsChange('output_nodes', updatedOutputs);
                        }
                    } }, { children: [_jsx(FontAwesomeIcon, { icon: faPlus }), _jsx(Spacer, { type: "narrow" }), "New Output"] })) })) : (_jsx(ScopeButtonWrapper, { children: _jsx(Label, { children: "Output limit reached" }) }))] }));
};
export default AsyncLogicOutputComponent;
